import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./Pages/authe";
import Layout from "./Component/Nave/Layout";
import ProtectedRoute from "./Component/ProtectedRout";
import HomePage from "./Pages/HomePage"; // فقط كمثال
import Emp from "./Pages/Emp"; // فقط كمثال
import AddEmp from "./Component/pages/emp/addEmp"; // فقط كمثال
import DetailsEmp from "./Component/pages/emp/EmployeeDetails"; // فقط كمثال
import EmployeesAlerts from "./Component/pages/emp/EmployeesAlerts"; // فقط كمثال
import EditEmp from "./Component/pages/emp/EditEmployee"; // فقط كمثال
import AddDoctor from "./Component/pages/Doctor/addDoctor";
import Doctor from "./Pages/Doctor";
import DoctorAlerts from "./Component/pages/Doctor/DoctorAlerts";
import DetailsDoctor from "./Component/pages/Doctor/DoctorDetails";
import DoctorEdit from "./Component/pages/Doctor/DoctorEdit";
import AddCenter from "./Component/pages/Center/addCenter";
import Center from "./Component/pages/Center/CenterList";
import CenterAlerts from "./Component/pages/Center/CenterAlerts";
import CenterDetails from "./Component/pages/Center/CenterDetails";
import CenterEdit from "./Component/pages/Center/CenterEdit";
import VendorsPage from "./Component/pages/vendors/VendorsPage";
import VendorDetailsPage from "./Component/pages/vendors/VendorDetailsPage";
import DepartmentList from "./Component/pages/Department/DepartmentList";
import AddDepartment from "./Component/pages/Department/addDepartment";

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<HomePage />} />
        <Route path="dashboard" element={<HomePage />} />
        <Route path="employees" element={<Emp />} />
        <Route path="employees/add" element={<AddEmp />} />
        <Route path="employees/:id" element={<DetailsEmp />} />
        <Route path="employees/alerts" element={<EmployeesAlerts />} />
        <Route path="employees/:id/edit" element={<EditEmp />} />
        {/* Doctor */}
        <Route path="doctors/add" element={<AddDoctor />} />
        <Route path="doctors" element={<Doctor />} />
        <Route path="doctors/alerts" element={<DoctorAlerts />} />
        <Route path="doctors/:id" element={<DetailsDoctor />} />
        <Route path="doctors/:id/edit" element={<DoctorEdit />} />        {/*Add Center*/}
        <Route path="centers/add" element={<AddCenter />} />
        <Route path="centers" element={<Center />} />
        <Route path="centers/alerts" element={<CenterAlerts />} />
        <Route path="centers/:id" element={<CenterDetails />} />
        <Route path="centers/:id/edit" element={<CenterEdit />} />
        {/* Departments */}
        <Route path="departments" element={<DepartmentList />} />
        <Route path="departments/add" element={<AddDepartment />} />

        {/* add vendors */}
        <Route path="vendors" element={<VendorsPage />} />
        <Route path="vendors/:id" element={<VendorDetailsPage />} />
      </Route>
    </Routes>
  );
}

export default App;
